<template>
  <div class="organizational-container">
    <el-card class="box-card organize-content">
      <div slot="header" class="clearfix">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item>权限查看</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="configure-container ovf-hidden">
        <!-- 左边部门组织树 -->
        <el-row class="h-100">
          <el-col :span="6" class="h-100">
            <el-card
              shadow="hover"
              body-style="width: 390px; height: 100%; margin: 0 auto"
            >
              <div class="left-depart-tree">组 织 层 级</div>

              <el-tree
                ref="tree"
                :data="data"
                highlight-current
                accordion
                check-strictly
                expand-on-click-node
                node-key="groupId"
                @node-drop="handleDrop"
                draggable
                :default-expanded-keys="treeExpandData"
                @node-click="handleRowClick"
                :props="defaultProps"
              >
                <div
                  class="custom-tree-node"
                  slot-scope="{ node, data }"
                  @mouseenter="mouseenter(data)"
                  @mouseleave="mouseleave(data)"
                  style="vertical-align: middle"
                >
                  <span v-if="data.edit">
                    <!-- v-model -->
                    <el-input
                      v-model="data.groupName"
                      placeholder="请输入内容"
                      @keyup.enter.native="handleEdit(data)"
                      size="small"
                    ></el-input>
                    <el-button
                      type="text"
                      size="small"
                      @click="handleEdit(data)"
                      >保存</el-button
                    >
                  </span>
                  <div v-else>
                    <span>{{ node.label }}</span>
                    <span style="margin-right: 10px">
                      <el-link
                        v-show="data.del"
                        size="small"
                        type="info"
                        @click.stop.prevent="() => edit(data)"
                        style="float: right"
                        icon="el-icon-edit"
                      ></el-link>
                      <el-link
                        v-show="data.del"
                        size="small"
                        type="warning"
                        @click.stop.prevent="() => append(data)"
                        style="margin-right: 5px; float: right"
                        icon="el-icon-circle-plus-outline"
                      ></el-link>
                      <el-link
                        v-show="data.del"
                        size="small"
                        type="danger"
                        @click.stop.prevent="() => remove(node, data)"
                        style="margin-right: 5px; float: right"
                        icon="el-icon-remove-outline"
                      ></el-link>
                    </span>
                  </div>
                </div>
              </el-tree>
            </el-card>
          </el-col>
          <!-- 右边表格 -->
          <el-col :span="18" class="h-100">
            <div class="right-container h-100">
              <el-card
                shadow="hover"
                class="search-form"
                style="height: auto; margin-bottom: 10px"
              >
                <el-form
                  :inline="true"
                  :model="params"
                  class="demo-form-inline"
                  ref="params"
                  label-width="84"
                >
                  <el-form-item label="用户名称">
                    <el-input
                      v-model="params.userName"
                      placeholder="请输入用户名称"
                      size="small"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="用户状态">
                    <el-select
                      v-model="params.userStatus"
                      clearable
                      placeholder="请选择"
                      size="small"
                    >
                      <el-option label="全部" :value="-1"></el-option>
                      <el-option label="启用" :value="0"></el-option>
                      <el-option label="禁用" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="员工标识">
                    <el-select
                      v-model="params.selectUserTypeList"
                      clearable
                      multiple
                      placeholder="请选择"
                      size="small"
                    >
                      <el-option label="正式" :value="3"></el-option>
                      <el-option label="试用" :value="1"></el-option>
                      <el-option label="实习" :value="2"></el-option>
                      <el-option label="离职" :value="-1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="系统">
                    <el-select
                      v-model="params.selectSystemList"
                      clearable
                      multiple
                      placeholder="请选择系统"
                      size="small"
                    >
                      <el-option
                        v-for="item in companyOptions"
                        :key="item.companyId"
                        :label="item.companyName"
                        :value="item.companyId"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="默认部门">
                    <el-input
                      v-model="params.defaultPositionName"
                      placeholder="请输入默认部门"
                      size="small"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="onSearch()"
                      >查 询
                    </el-button>
                    <el-button type="primary" size="small" @click="toAddUser()"
                      >新 增
                    </el-button>
                    <el-button
                      type="primary"
                      size="small"
                      @click="copyUserInfo()"
                      >复 制
                    </el-button>
                    <el-button type="primary" size="small" @click="isposition()"
                      >配 置
                    </el-button>
                    <el-button type="primary" size="small" @click="transfer()"
                      >转移部门
                    </el-button>
                    <el-button
                      type="primary"
                      size="small"
                      @click="resetForm('params')"
                      >重 置
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-card>
              <el-card shadow="hover" class="table-list">
                <el-table
                  :data="userList"
                  v-loading="loading"
                  class="table-form"
                  style="height: 100%; display: flex; flex-direction: column"
                  ref="multipleTable"
                  :header-cell-style="{
                    background: '#eef1f6',
                    color: '#606266',
                    fontWeight: 'bolder',
                  }"
                  @row-click="handleTableRowClick"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column label="选择" width="55" type="selection">
                  </el-table-column>
                  <el-table-column label="姓名" align="center">
                    <template slot-scope="scope">
                      <img
                        src="../../assets/image/special-role.png"
                        v-show="scope.row.specialRoleAuth"
                        style="width: 14px; height: 14px"
                      />
                      {{ scope.row.realName }}
                    </template>
                  </el-table-column>
                  <el-table-column label="部门" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.departInfos }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="邮箱" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.userEmail }}
                    </template>
                  </el-table-column>
                  <el-table-column label="用户状态" align="center">
                    <template slot-scope="scope">
                      <el-switch
                        v-model="scope.row.userStatus"
                        active-color="#409eff"
                        inactive-color="#dcdfe6"
                        :active-value="0"
                        :inactive-value="1"
                        @change="updateStatus(scope.row, scope.$index)"
                      ></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column label="员工标识" align="center">
                    <template slot-scope="scope">
                      <el-tag
                        v-if="
                          scope.row.workingStatus == 0 &&
                          scope.row.userType == 3
                        "
                        size="small"
                        type="success"
                        >正式
                      </el-tag>
                      <el-tag
                        v-if="
                          scope.row.workingStatus == 0 &&
                          scope.row.userType == 1
                        "
                        size="small"
                        type="warning"
                        >试用
                      </el-tag>
                      <el-tag
                        v-if="
                          scope.row.workingStatus == 0 &&
                          scope.row.userType == 2
                        "
                        size="small"
                        type="danger"
                        >实习
                      </el-tag>
                      <el-tag
                        v-if="
                          scope.row.workingStatus == 1 ||
                          scope.row.userType == -1
                        "
                        size="small"
                        type="info"
                        >离职
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="系统"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ scope.row.companyInfo }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="240">
                    <template slot-scope="scope">
                      {{ scope.row.userOperation }}
                      <i class="el-icon-key" color="blue"></i>
                      <el-button type="text" @click="resetPassword(scope.row)"
                        >重置密码
                      </el-button>
                      <el-button
                        type="text"
                        @click="configurePermission(scope.row)"
                        >特殊权限
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!-- 复制 -->
    <el-dialog
      title="复制"
      :visible.sync="copyVisible"
      width="30%"
      top="5vh"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        :model="copyRuleForm"
        :rules="rules"
        ref="copyRuleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="源用户" prop="userCode">
          <el-select
            size="small"
            style="width: 100%"
            v-model="copyRuleForm.userCode"
            placeholder="请选择源用户"
            clearable
            filterable
          >
            <el-option
              v-for="item in userAllList"
              :key="item.userId"
              :label="`${item.realName}-${item.defaultPositionName}`"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCopy('copyRoleForm')"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 转移部门 -->
    <el-dialog
      title="转移部门"
      :visible.sync="transVisible"
      width="30%"
      top="5vh"
      append-to-body
      :before-close="handleClose"
    >
      <el-tree
        ref="tree"
        :data="data"
        highlight-current
        accordion
        :check-strictly="true"
        show-checkbox
        expand-on-click-node
        node-key="groupId"
        :default-expanded-keys="treeExpandData"
        @check-change="checkChange"
        :props="defaultProps"
      >
        <div
          class="custom-tree-node"
          slot-scope="{ node }"
          style="vertical-align: middle"
        >
          <div>
            <span>{{ node.label }}</span>
          </div>
        </div>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTransfer('transRuleForm')"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDepartInfoList,
  pageFindUserList,
  findSystemInfo,
  getAllCompanyInfo,
  configOrganize,
  updateUserStatus,
  findUserInfo,
  copyJurisdiction,
  transJurisdiction,
  resetPasswordMange,
  removeNode,
  editNode,
  appendNode,
  handleDrop,
} from "@/api/organizeMange";
import { unique, hasBtnPermission } from "@/utils";
// import { mapState, mapMutation } from "vuex";
import { getSystemData } from "@/api/systemMange";

export default {
  name: "Organizational",
  data() {
    return {
      multipleSelection: [],
      copyVisible: false,
      transVisible: false,
      loading: false,
      value: true,
      dialogVisible: false,
      buttonText: "开始配置",
      isEdit: true,
      loading: true,
      data: [], // 部门列表数组
      userList: [], // 用户列表
      treeExpandData: [], // 默认展开的数组
      totalCount: null, // 用户总人数
      selectUser: [], // 用户选择列表
      tableCheck: "",
      params: {
        companyId: null,
        companyIds: "",
        groupIds: "",
        pageNo: 1,
        pageSize: 1000,
        roleId: null,
        userCode: null,
        userStatus: "",
        userName: "",
        userType: null,
        userTypes: "",
        defaultPositionName: "", // 默认部门名称
        selectSystemList: [],
        selectUserTypeList: [],
      },
      companyOptions: [],
      userIds: {
        userId: "",
        passWord: "",
      },
      userType: "",
      userName: "",
      query: {
        roleName: "",
        userCode: [],
      },
      checkPositionAll: false,
      checkRoleAll: false,
      isIndeterminate: false,
      isRoleIndeterminate: false,
      checkedCompanyList: [], // 选择的系统列表
      systemList: [], // 系统列表
      initSystemList: [], // 默认初始列表
      positionList: [], // 岗位列表
      roleList: [], // 角色列表
      defaultProps: {
        children: "children",
        label: "groupName",
      },
      companyProps: {
        children: "children",
        label: "companyName",
      },
      selectPositionList: [],
      selectRoleList: [],
      selectSystemList: [], //查询中选择的系统列表
      selectUserTypeList: [], //查询中选择的的员工标识列表
      requestParams: {
        userCode: [],
        selectPositionList: [],
        selectRoleList: [],
        companyId: null, //选择的系统ID列表
        groupId: "",
      },
      userAllList: [],
      rules: {
        userCode: [
          {
            required: true,
            message: "请选择源用户",
            trigger: ["change", "blur"],
          },
        ],
        groupId: [
          {
            required: true,
            message: "请选择源部门",
            trigger: ["change", "blur"],
          },
        ],
      },
      copyLoading: false,
      // 复制
      value: [],
      copyRuleForm: {
        userCode: null,
        userCodes: [],
      },
      transRuleForm: {
        groupId: "",
        userCode: [],
      },
    };
  },

  computed: {
    tableHeight: function () {
      return window.innerHeight - 350 + "px";
    },
  },
  watch: {
    "requestParams.groupId"(newVal, oldVal) {
      if (newVal) {
        this.getOrganizeUserList();
      }
    },
    selectUser(newVal, oldVal) {
      if (this.isEdit && newVal.length > 0) this.getSystemList();
    },
  },

  created() {
    this.getDepartTreeList();
    this.getOrganizeUserList();
    this.getAllSystemInfo();
    this.$store.commit("setUserList", []); //置空
  },

  methods: {
    //新增用户
    toAddUser(e, item) {
      // if (!hasBtnPermission("sys:user:save")) {
      //   this.$message.warning("您暂无权限操作");
      //   return;
      // }
      this.$router.push("/sys/addUser");
    },
    //重置
    resetForm(params) {
      // this.$refs[params].resetFields();
      this.params.userName = "";
      this.params.userStatus = "";
      this.params.selectSystemList = "";
      this.params.selectUserTypeList = "";
    },
    //鼠标移动tree按钮显示与消失
    mouseenter(data) {
      this.$set(data, "del", true);
    },
    mouseleave(data) {
      this.$set(data, "del", false);
    },
    //新增、删除、修改节点
    async handleEdit(data) {
      if (data.groupName.length > 0) {
        data.userCode = JSON.parse(
          window.sessionStorage.getItem("userInfo")
        ).userId;
        if (data.groupId) {
          const res = await editNode(data);
          if (res.code == 200) {
            this.$message.success("修改成功");
            this.getDepartTreeList();
          } else {
            this.$message.error(res.msg);
          }
        } else {
          const res = await appendNode(data);
          if (res.code == 200) {
            this.$message.success("添加成功");
            this.getDepartTreeList();
          } else {
            this.$message.error(res.msg);
          }
        }
        data.edit = false;
      }
    },
    edit(data) {
      if (!data.edit) {
        this.$set(data, "edit", true);
      }
      data.edit = true;
    },

    append(data) {
      const newChild = {
        groupId: null,
        label: "",
        children: [],
        edit: true,
        companyId: -1,
        sortNo: 1,
        groupParentId: data.groupId,
        userCode: JSON.parse(window.sessionStorage.getItem("userInfo")).userId,
      };
      if (!data.children) {
        this.$set(data, "children", []);
      }
      data.children.push(newChild);
    },

    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex((d) => d.groupId === data.groupId);
      if (node.childNodes.length != 0) {
        this.$message({
          message: "该节点下存在子节点，不允许直接删除",
          type: "warning",
        });
        return;
      } else {
        this.$confirm("确定删除该部门吗", "提示")
          .then((_) => {
            this.confirmDeleteGroup(data.groupId);
          })
          .catch((_) => {});
      }
    },
    async confirmDeleteGroup(groupId, children) {
      let params = {
        companyId: -1,
        groupId,
      };
      const res = await removeNode(params);
      if (res.code === "200") {
        this.$message.success("删除成功");
        this.getDepartTreeList();
      } else {
        this.$message.error(res.msg);
      }
    },

    //重置密码
    resetPassword(row) {
      this.userIds.userId = row.userId;
      this.userIds.passWord = row.passWord;
      this.userIds.passWord = "123456";
      this.$confirm("是否确定重置密码？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((_) => {
          this.confirmButtonText(this.userIds);
        })
        .catch((_) => {});
    },
    async confirmButtonText() {
      const res = await resetPasswordMange(this.userIds);
      if (res.code === "200") {
        this.$alert("重置密码成功 当前密码为“123456”。", "信息提示", {
          confirmButtonText: "确定",
          type: "success",
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    // 查询主组织部门列表
    async getDepartTreeList() {
      const res = await getDepartInfoList(
        JSON.parse(window.sessionStorage.getItem("userInfo")).userId
      );
      if (res.code === "200") {
        this.data = res.data;
        let provincialCenterId = this.data[0].groupId; //默认展开第一个节点
        this.treeExpandData.push(provincialCenterId);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 转移部门tree变单选
    checkChange(data, checked, node) {
      this.transRuleForm.groupId = data.groupId;
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
      }
    },
    //转移部门
    transfer() {
      if (this.$store.state.selectUserList.length == 0) {
        this.$message.warning("请先选择用户");
        return;
      } else {
        this.$store.state.selectUserList.forEach((item) => {
          this.transRuleForm.userCode.push(item.userId);
        });
      }
      this.transVisible = true;
      this.getDepartTreeList();
    },
    async confirmTransfer() {
      // this.transRuleForm.userCode = this.transRuleForm.userCode.toString();
      const res = await transJurisdiction(this.transRuleForm);
      if (res.code === "200") {
        this.$message.success("转移成功");
        this.transVisible = false;
        this.getOrganizeUserList();
      } else {
        this.$message.error(res.message);
      }
      this.transRuleForm.groupId = "";
      this.transRuleForm.userCode = [];
    },
    // 查询主组织用户列表
    async getOrganizeUserList() {
      this.loading = true;
      this.params.groupIds = this.requestParams.groupId;
      this.params.companyIds = JSON.parse(
        JSON.stringify(this.params.selectSystemList)
      ).toString();
      this.params.userTypes = JSON.parse(
        JSON.stringify(this.params.selectUserTypeList)
      ).toString();
      this.params.userCode = JSON.parse(
        window.sessionStorage.getItem("userInfo")
      ).userId;
      this.params.realName = this.params.userName;
      const res = await pageFindUserList(this.params);
      if (res.code === "200") {
        this.userList = res.data.list;
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    //查询用户信息
    onSearch() {
      this.getOrganizeUserList();
    },
    //更新用户状态
    async updateStatus(item, index) {
      const status = item.userStatus;
      let params = {
        userId: item.userId,
        userStatus: item.userStatus,
      };
      const res = await updateUserStatus(params);
      if (res.code === "200") {
        status === 1
          ? this.$message.success("禁用成功")
          : this.$message.success("启用成功");
        status == 1
          ? (this.userList[index].userStatus = 1)
          : (this.userList[index].userStatus = 0);
      } else {
        this.userList[index].userStatus = 1;
      }
    },
    // 查询所有系统信息
    async getAllSystemInfo() {
      let searchSystemParams = {
        pageNo: 1,
        pageSize: 100,
        userCode: JSON.parse(
          window.sessionStorage.getItem("userInfo")
        ).userId.toString(),
      };
      const res = await getSystemData(searchSystemParams);
      if (res.code === "200") {
        this.companyOptions = res.data.list;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 根据选择的用户查询用户所拥有系统
    async getSystemList() {
      this.query.userCode = [];
      this.selectUser.forEach((item) => {
        this.query.userCode.push(item.userId);
      });
      const res = await findSystemInfo(this.query);
      if (res.code === "200") {
        this.systemList = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleTableRowClick(row, column, event) {
      this.selectUser = [];
      this.selectUser.push(row);
      this.tableCheck = row;
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    // 用户选择列表
    handleSelectionChange(e) {
      this.$store.commit("setUserList", e);
    },
    handleClose() {
      this.copyVisible = false;
      this.transVisible = false;
    },
    //复制
    copyUserInfo() {
      this.copyRuleForm.userCodes = this.$store.state.selectUserList.map(
        (item) => item.userCode
      );
      if (this.copyRuleForm.userCodes.length == 0) {
        this.$message.warning("请先选择用户");
        return;
      }
      this.copyVisible = true;
      this.getPageUserInfo();
    },
    async getPageUserInfo() {
      const res = await findUserInfo();
      if (res.code === "200") {
        this.userAllList = res.data;
      } else {
        this.$message.error(res.msg);
      }
      this.userAllList = res.data;
    },
    async confirmCopy() {
      this.copyRuleForm.userCodes = this.$store.state.selectUserList.map(
        (item) => item.userId
      );
      const res = await copyJurisdiction(this.copyRuleForm);
      if (res.code === "200") {
        this.$message.success("复制成功");
        this.copyVisible = false;
      } else {
        this.$message.error(res.message);
      }
    },
    // 组织架构点击事件
    handleRowClick(data, node) {
      this.requestParams.groupId = data.groupId;
    },
    //拖拽树节点
    async handleDrop(draggingNode, dropNode, dropType, ev) {
      this.data.forEach((item) => {
        this.setGroupTree(item, item.groupId);
      });

      // 请求
      const res = await handleDrop(this.data);
      if (res.code === "200") {
      } else {
        this.$message.error(res.msg);
      }
    },

    // 递归生成树
    setGroupTree(tree, parentId) {
      if (
        typeof tree !== "object" ||
        tree === null ||
        !tree.children ||
        !tree.children.length
      ) {
        return;
      }

      tree.children.forEach((item, index) => {
        this.setGroupTree(item, item.groupId);

        item.sortNo = index + 1;
        item.groupParentId = parentId;
      });
    },

    //判断是否存在部门
    isposition() {
      if (this.$refs.multipleTable.selection.length === 0) {
        this.$store.commit("setUserList", this.userList);
        // this.$message.warning("请先选择用户");
        // return;
      }

      this.$store.state.selectUserList.forEach((item) => {
        if (item.departInfos === "无部门") {
          this.$message.warning("不能选择无部门人员");
          throw Error("此人暂无部门");
        }
      });
      this.$router.push("/sys/organizational/startconfigure");
    },
    // 进入特殊权限配置
    configurePermission(item) {
      this.$router.push({
        path: "/sys/user/custompermission",
        query: {
          id: item.userId,
        },
      });
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item{
  margin: 10px 0 10px 20px;
}
::v-deep .box-card {
  flex: 1;
  height: 100%;
}

::v-deep .box-card:nth-child(2) {
  margin: 0 10px;
}

::v-deep .box-card:last-child {
  flex: 2;
}

::v-deep .el-tree-node__content::before {
  content: "";
  padding-left: 10px;
}

::v-deep .el-checkbox__input {
  margin-right: 6px;
}

::v-deep .el-collapse-item__header {
  height: 40px;
  background-color: #f4f4f4;
  padding: 0 10px;
}

::v-deep .levelname {
  margin-right: 10px;
}

::v-deep .el-checkbox__label {
  line-height: 30px;
}

::v-deep .el-radio-group {
  display: flex;
  line-height: 40px;
}

::v-deep .el-radio {
  margin-right: 20px;
}

::v-deep .el-radio__label {
  margin-left: 0;
}

::v-deep .el-icon-edit {
  color: #1a1adf;
}

::v-deep .el-descriptions-item__label.has-colon::after {
  content: "" !important;
}

::v-deep .el-tree-node .is-focusable {
  padding: 3px 0;
}

::v-deep .el-form-item__label {
  width: 72px;
}

::v-deep .el-card__body {
  padding: 5px;
  overflow: hidden;
  height: 100%;
}

::v-deep .el-table__body-wrapper {
  flex: 1;
  overflow-y: auto;
}

::v-deep .is-hover-shadow {
  margin-right: 10px;
}

::v-deep .el-card.table-list.is-hover-shadow {
  flex: 1;
}

/* ::v-deep .el-descriptions-item__container{
  margin-top: 10px;
} */
</style>
<style lang='scss' scoped>
// ::v-deep .left-text .el-input__inner {
//   height: 20px;
//   line-height: 20px;
//   padding: 1px;
// }
.custom-tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  // .left-text {
  //   width: 20px;
  // }
}

.show-hide:hover:ntn-child(2) {
  display: inline-block !important;
}

.organizational-container {
  height: 100%;
  overflow: hidden;

  .organize-content {
    display: flex;
    flex-direction: column;

    .configure-container {
      height: 100%;
      display: flex;
      justify-content: space-between;

      .left-depart-tree {
        border-radius: 5px;
        background-color: #409eff;
        height: 30px;
        width: 100%;
        text-align: center;
        line-height: 30px;
        color: #ffffff;
        font-weight: bold;
      }

      .left-tree {
        margin-right: 10px;
      }

      .right-container {
        display: flex;
        flex-direction: column;
      }
    }

    .el-card {
      height: 100%;
      .table-list {
        // .is-hover-shadow {
        //   flex: 1;
        // }
      }
    }
  }

  .el-scrollbar {
    width: 100%;
    height: 100%;
  }

  .container-right {
    display: flex;

    .position-container {
      flex: 1;
    }
  }

  .right-tree {
    margin-bottom: 20px;

    .el-tree {
      margin: 12px 0;
    }
  }
}

.ovf-hidden {
  height: 100%;
  overflow: hidden;
}

.h-100 {
  height: 100%;
}
</style>